<template>
  <div class="page_info_box">
    <van-image class="page_logo" :src="require('../assets/zzb-B.png')"></van-image>
    <!-- 下载 -->
    <div class="button_box">
      <div v-if="appFlag == 20" @click="getLatestVersion(20)">
        <van-image :src="require('../assets/icon-iOS@2x.png')"></van-image>
        <span>iPhone下载</span>
      </div>
      <div v-if="appFlag == 10" @click="getLatestVersion(10)">
        <van-image :src="require('../assets/icon-Android@2x.png')"></van-image>
        <span>Android下载</span>
      </div>
    </div>
    <img class="bottom_img" src="../assets/background_bottom_b@2x.png" alt="">
    <!-- 遮罩 -->
    <van-overlay :show="show" @click="show">
      <img class="download-icon" src="@/assets/download.png" alt="">
      <p class="download-text">请在默认浏览器中打开下载！</p>
    </van-overlay>
  </div>
</template>

<script>
  import { getLatestVersionB } from '@/api/index'
  export default {
    data() {
      return {
        show: false,
        appFlag: this.isSystem() == 'ios' ? 20 : 10,
      }
    },
    methods: {
      // 判断
      weixin(){
        var ua = window.navigator.userAgent.toLowerCase();
        if(ua.match(/MicroMessenger/i) == 'micromessenger'){
          return true
        } else {
          return false
        }
      },
      // 下载内容
      getLatestVersion(data){
        let isSystemType = this.isSystem() == 'ios' ? 'ios' : 'Android';
        if(data != this.appFlag){
          this.$dialog.alert({
            message: '您当前的机型为'+ isSystemType +',请下载对应版本！',
            className: 'dialogbox'
          }).then(() => {});
          return
        }
        getLatestVersionB({ clientType: data }).then(res => {
          this.$dialog.confirm({
              message: '确定要下载'+ isSystemType +'版本APP吗？',
              className: 'dialogbox'
            })
            .then(() => {
              window.location.href = res.data.releaseUrl;
              this.show = true;
            })
            .catch(() => {});
        })
      }
    }
  }
</script>
  
<style lang="scss" scoped>
@mixin direction {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.page_info_box {
  width: 100%;
  min-height: 100vh;
  background-image: url('../assets/page_background@2x.png');
  background-size: 100% auto;
  background-repeat: no-repeat;
  @include direction;
}
.bottom_img {
  width: 304px;
  position: absolute;
  bottom: 0;
}
.page_logo {
  width: 145px;
  margin-top: 41px;
}
.button_box {
  width: 100vw;
  @include direction;
  margin-top: 45px;
  div {
    width: 173px;
    height: 36px;
    background: linear-gradient(128deg, #FFA7AA 0%, #C54C51 100%);
    opacity: 1;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .van-image {
      width: 18px;
      height: 18px;
      margin-left: 35px;
    }
    span {
      font-size: 14px;
      font-weight: 500;
      color: white;
      margin-right: 30px;
    }
  }
}
.download-icon{
  position: absolute;
  right: 2vw;
  top: 2vh;
  width: 10vw;
}
.download-text{
  font-size: 16px;
  color: white;
  position: absolute;
  right: 2vw;
  top: 6vh;
}
</style>